// extracted by mini-css-extract-plugin
module.exports = {"container":"dece2e673c--container--bG3lp","buttons_container":"dece2e673c--buttons_container--NNIki","left_block":"dece2e673c--left_block--BD1pw"};